
// src/web/components/toggle-button.jsx

import React from 'react'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  Avatar
} from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'
import theme from './themes/toggle-button.css'
import { translate } from 'react-i18next'

function ToggleButton(props) {
  const {
    t,
    flag,
    trueIcon = 'arrow_drop_down',
    falseIcon = 'arrow_drop_up',
    trueLabel = t('label:すべて表示'),
    falseLabel = t('label:隠す'),
    i18nLoadedAt, i18n,
    isAttachment,
    image,
    ...others,
  } = props
  if(image)
    return (<Button theme={theme}
      {...others} >
        {flag && <FontIcon className={theme.fontIcon} value='arrow_drop_down' />|| <FontIcon className={theme.fontIcon} value='arrow_drop_up' />}
        {flag && <Avatar theme={theme} image={image} />}
        {flag && trueLabel || falseLabel}
        {isAttachment &&
          <FontIcon className={theme.fontIcon} value='attachment' />
        }
    </Button>)
  else
    return (<Button theme={theme}
      icon={flag && trueIcon || falseIcon}
      label={flag && trueLabel || falseLabel}
      {...others} >
        {isAttachment &&
          <FontIcon className={theme.fontIcon} value='attachment' />
        }
    </Button>)
}

export default translate()(ToggleButton)



// WEBPACK FOOTER //
// ./src/web/components/toggle-button.jsx